import icon from '@/presentation/assets/images/icons/tool-novelty.svg';
import { AiAgentEnvService } from '@telecom/shared/services/ai-agent-env-service/ai-agent-env-service';
import type { CustomQueryParams } from '@/services/router-proxy/types';
import { type Manifest, type RouterConfig, type ToolConfig, PAGE_TYPE } from '@/types/manifest.ts';
import { NOVELTY_ROUTER_NAME } from '@/domains/novelty-check-report/constants';
import { injectService } from '@patsnap/tahiti-core';

const LAYOUT_QUERY_PARAM = 'layout';
const LAYOUT_IN_AGENT = 'agent';

function getLayout() {
    const url = location.href;
    const searchParams = new URLSearchParams(url.split('?')[1]);
    return searchParams.get(LAYOUT_QUERY_PARAM);
}

const routerConfig: RouterConfig = {
    type: PAGE_TYPE.TOOL,
    name: NOVELTY_ROUTER_NAME,
    exclusiveRoutePath: '/novelty-check-report',
    getComponent: () => {
        return import('./NoveltyCheckReportEntry.vue');
    },
};


const toolConfig: ToolConfig = {
    tabIndex: 1,
    label: 'drafting.Novelty',
    icon,
    aclCheckPath: (permission) => permission.noveltyCheckReport,
};

export const manifest: Manifest = {
    ...routerConfig,
    ...toolConfig,
};

declare module '@patsnap/tahiti-core' {
    export interface CommandService {
        /**
         * 去到 Novelty Check Report 页面
         * @param commandId - 命令(去到 Novelty Check Report 页面)
         * @param params - 参数(包含任务 ID)
         */
        executeCommand(commandId: 'command:route:novelty-check-report', params?: CustomQueryParams): void;
        /**
         * 去到 Novelty Check Report 页面(新窗口打开)
         * @param commandId - 命令(去到 Novelty Check Report 页面(新窗口打开))
         * @param taskId - 任务 ID, 如果未提供，即创建新任务
         */
        executeCommand(commandId: 'command:route:novelty-check-report:new-tab', taskId?: string): void;
    }
}
